<template>
    <div
        v-bind="obData.attributes"
        @click="handlerClickGoogle"
        style="height: 100%"
        class="product-card-wrapper"
    >
        <div class="product-card" @click="storeBlock($el)">
            <DefLabels :result="obData.labels" />
            <a :href="obData.detailPage">
                <CardSlider :result="obData.pictures"/>
            </a>
            <def-like :result="obData" v-if="isAuthorized"/>
            <div
                v-if="getPageWidth() >= 992"
                @click="handlerOpenProductDetail"
                class="product-card__view"
            >
                {{ messages.detail }}
            </div>
            <div class="product-card__block" v-if="obData.price">
                <span v-if="obData.offer.price.printDiscountPercent"
                      class="product-card__discount">{{ obData.offer.price.printDiscountPercent }}</span>
                <a :href="obData.detailPage" class="product-card__name">{{ obData.name }}</a>
                <div>
                    <span class="product-card__price">{{ obData.offer.price.printPrice }}</span>
                    <span v-if="+obData.offer.price.printPrice !== +obData.offer.price.printPriceOld"
                          class="product-card__oldPrice">{{ obData.offer.price.printPriceOld }}</span>
                </div>
            </div>
        </div>
        <div v-if="getPageWidth() >= 992">
            <!--Быстрый просмотр-->
            <vue-popup
                v-model="openQuickView"
                :styles="{maxWidth: '1024px'}"
            >
                <product-detail
                    :popupMode="true"
                    @close="openQuickView = false"
                    @openModalBuy="toggleAddToBasket = true; addToBasketData = $event;"
                />
                <quick-view-form
                    :product="obData"
                    @close="openQuickView = false"
                />
            </vue-popup>
            <vue-popup v-model="toggleAddToBasket" :styles="{maxWidth: '790px'} ">
                <addToBasketModal :result="addToBasketData" @close="toggleAddToBasket = false;"/>
            </vue-popup>
        </div>
    </div>
</template>

<script>
    import {mapState, mapActions} from "vuex";

    const item = require('../../../MOCKED_DATA/catalog-page').catalogData.catalogSectionList.items[0];

    export default {
        name: 'ProductCard',
        props: {
            result: {
                type: Object,
                default: () => item
            },
            messages: {
                type: Object,
                default: () => ({
                    detail: 'Детальнее'
                })
            },
            dataLayer: {
                type: Object,
            }
        },
        data() {
            return {
                openQuickView: false,
                obData: this.result,
                obDataLayer: this.dataLayer,
                toggleAddToBasket: false,
                addToBasketData: {}
            }
        },
        computed:{
            ...mapState({
                isAuthorized: ({personal}) => personal.data.authInfo?.isAuthorized,
            })
        },
        methods: {
            ...mapActions({
                getPageData: 'product/getPageData',
            }),
            async handlerOpenProductDetail() {
                await this.getPageData({ url: this.result.detailPage });
                this.openQuickView = true;
            },
            storeBlock($el) {
                localStorage[window.location.href] = $($el).attr("id");
            },
            getPageWidth() {
                return window.innerWidth;
            },
            handlerClickGoogle() {
                try {
                    if (this.obDataLayer) {
                        const product = this.obDataLayer.data[this.obData?.offer?.id ?? this
                            ?.obData?.id];

                        dataLayer.push({
                            'ecommerce': {
                                'currencyCode': this.obDataLayer.currencyCode,
                                'click': {
                                    'actionField': {'list': 'List 1'},
                                    'products': [{
                                        'name': product.name,
                                        'id': product.id,
                                        'price': product.price,
                                        'brand': 'Love you',
                                        'category': product.category,
                                        'variant': product.variant,
                                        'position': product.position,
                                    }]
                                }
                            },
                            'event': 'gtmUaEvent',
                            'gtmUaEventCategory': 'Enhanced Ecommerce',
                            'gtmUaEventAction': 'Product Clicks',
                            'gtmUaEventNonInteraction': 'False'
                        });
                    }
                } catch (err) {
                    console.error(err);
                }
            }
        },
        mounted() {
            // console.log(this.result);
        },

    }
</script>

<style lang="scss" scoped>
.product-card {
    background-color: #ffffff;
    display: flex;
    flex-direction: column;
    text-align: center;
    justify-content: center;
    font-weight: 500;
    color: #191918;
    font-size: rem(14);
    letter-spacing: 0.08em;
    position: relative;
    height: 100%;
    @include point-md {
        font-size: rem(16);
    }



    &__discount {
        display: block;
        color: var(--discount-color);
        margin-bottom: 4px;
        font-size: rem(10);
        letter-spacing: 0.1em;
        height: 12px;
        @include point-md {
            font-size: rem(12);
        }
    }

    &__name {
        display: block;
        margin-bottom: 12px;
        @include point-md {
            margin-bottom: 18px;
        }
    }

    &__price {
        color: #363636;
    }

    &__oldPrice {
        color: #757575;
        text-decoration: line-through;
    }

    &__block {
        padding: 8px;
        @include point-md {
            padding: 16px;
        }
        @include point-lg {
            padding: 12px 24px 24px;
        }
    }

    &__view {
        display: flex;
        align-items: center;
        justify-content: center;
        height: 32px;
        background: var(--background-colour-primary);
        font-weight: 500;
        font-size: rem(14);
        text-transform: uppercase;
        color: #467496;
        opacity: 0;
        transition: .3s linear opacity;
        &:hover{
            cursor: pointer;
        }
    }

    &:hover {

        .product-card__view {
            opacity: 1;
        }

    }

    :deep{
        .def-like {
            position: absolute;
            top: 16px;
            right: 16px;
        }
        .def-labels{
            position: absolute;
            top: 15px;
            left: 15px;
            z-index: 2;
        }
    }
}
.product-card-wrapper{
    height: 100%;
}
</style>